<div class="employment-section" [formGroup]="formGroup">
  <p class="note"><b>Employment History including Insurance or Financial Advisory Experience for the past 10 years.</b>
    (In reverse chronological order, including periods of self/ part-time/ full time/ commission-based employment or
    unemployment, starting with the most recent employer. Any gaps in employment history of 1 month or more must be
    accounted for. Please include any previous employment with Financial Institution or occupation that is related to
    Insurance or Financial Advisory Experience even if period of employment is more than 10 years ago.)
  </p>

  <div [formArrayName]="controlName">

    <div *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i"
      class="qualification-card row g-3 align-items-end">

      <!-- Date Range -->
      <!-- Enlistment Date -->
      <div class="col-md-6">
        <mat-label class="field-label">Start Date</mat-label>
        <mat-form-field class="w-100">

          <input matInput formControlName="startDate" [matDatepicker]="picker1"  placeholder="MM/YYYY" required>
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 startView="multi-year" (monthSelected)="setstartDateMonthAndYear($event, picker1,i)"
            panelClass="month-picker"></mat-datepicker>
          @let startDateControl = item.get('startDate');

          @if(startDateControl?.invalid && (startDateControl?.touched || startDateControl?.dirty)) {
          <mat-error>
            @if(startDateControl?.errors?.['required']) {
            <span>{{message}}</span>
            }@else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- ORD Date -->
      <div class="col-md-6">
        <mat-label class="field-label">End Date</mat-label>
        <mat-form-field class="w-100">

          <input matInput formControlName="endDate" [matDatepicker]="picker2"  placeholder="MM/YYYY" required>
          <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 startView="multi-year" (monthSelected)="setendDateMonthAndYear($event, picker2,i)"
            panelClass="month-picker"></mat-datepicker>
          @let endDateControl = item.get('endDate');
          @if(endDateControl?.invalid && (endDateControl?.touched || endDateControl?.dirty)) {
          <mat-error>
            @if(endDateControl?.errors?.['required']) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>
      @if(item.errors?.['invalidDateRange']){
      <mat-error>
        <span> End date must be after start date.</span>
      </mat-error>
      }

      <!-- employer -->
      <div class="col-md-6">
        <label class="field-label">Employer</label>
        <mat-form-field class="w-100">
          <input matInput formControlName="employer" required>
          @let employerControl = item.get('employer');
          @if(employerControl?.invalid && (employerControl?.touched || employerControl?.dirty)) {
          <mat-error>
            @if(employerControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- position -->
      <div class="col-md-6">
        <label class="field-label">Last Position Held</label>
        <mat-form-field class="w-100">
          <input matInput formControlName="position" required>
          @let positionControl = item.get('position');
          @if(positionControl?.invalid && (positionControl?.touched || positionControl?.dirty)) {
          <mat-error>
            @if(positionControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Employment type -->
      <div class="col-md-6">
        <label class="field-label">Nature of Employment (Full-time, Part-time, Contract, Internship)</label>
        <mat-form-field class="w-100">
          <mat-select matInput formControlName="employment" placeholder="Select employment" required>

            <mat-option value="Full-time">Full-time</mat-option>
            <mat-option value="Part-time">Part-time</mat-option>
            <mat-option value="Contract">Contract</mat-option>
            <mat-option value="Internship">Internship</mat-option>

          </mat-select>
          @let employmentControl = item.get('employment');
          @if(employmentControl?.invalid && (employmentControl?.touched || employmentControl?.dirty)) {
          <mat-error>
            @if(employmentControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- reason -->
      <div class="col-md-6">
        <label class="field-label">Reason for Leaving (Voluntary / Involuntary)</label>
        <mat-form-field class="w-100">
          <mat-select matInput formControlName="reason" placeholder="Select reason" required>
            <mat-option value="Voluntary">Voluntary</mat-option>
            <mat-option value="Involuntary">Involuntary</mat-option>
          </mat-select>
          @let reasonControl = item.get('reason');
          @if(reasonControl?.invalid && (reasonControl?.touched || reasonControl?.dirty)) {
          <mat-error>
            @if(reasonControl?.errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="row g-3">
        <!-- mail -->
        <div class="col-md-6">
          <label class="field-label">Employer Contact Details (Email Address)</label>
          <mat-form-field class="w-100">
            <input matInput formControlName="email" required>
            @let emailControl = item.get('email');
            @if(emailControl?.invalid && (emailControl?.touched || emailControl?.dirty)) {
            <mat-error>
              @if(emailControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

      </div>

      <!-- Delete -->
      <div class="col-md-3 text-end">
        @if (formArray.length > 1 && readonly() == false) {
        <button mat-stroked-button color="warn" type="button" (click)="removeRow(i)"><mat-icon>delete</mat-icon>Delete
          Employment History</button>
        }
      </div>

    </div>

  </div>
  @if(readonly() === false){
  <!-- Add Button -->
  <div class="text-end mt-3">
    <button mat-stroked-button color="primary" type="button" (click)="addRow()">
      + Add Employment History
    </button>
  </div>
  }

</div>
@if(readonly() === false){
<!-- Form Actions -->
<div class="form-actions">

  <button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}